import styled from 'styled-components'
import HeroActionsBase from 'components/hero-actions'

export const HeroActions = styled(HeroActionsBase)`
    margin-block-end: 24px;
`